<template>
  <div>
      <el-row class="mt-2">
          <b class="font_extralarge">导出学时详细信息</b>        
      </el-row>
      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 选择学员</b>        
      </el-row>

      <el-row class="mt-2">
          <PersonSelect @onValueChanged="onPersonChanged"></PersonSelect>
      </el-row>

      <el-row class="mt-2">
          <b class="font_base">2. 已选择学员</b>        
      </el-row>

      <el-row class="mt-2 overflow-y-auto h400px">
        <div v-for="(item,index) in selectPersons" :key="item.id" class="flex font-content mt-1 ">
          <div class="font-color-primary">{{ item.id }}</div>
          <div class="ml-4 font-color-primary w600px">{{ item.label }}</div>
          <div class="ml-4 cursor-pointer underline font-color-content" @click="selectPersons.splice(index,1);reloadCache();">移除</div>
        </div>
      </el-row>

      <el-row class="mt-2">
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">导出</el-button>
      </el-row>
  </div>
</template>

<script>
import { SchedulingSelect } from "@/views/components/select"
import PersonSelect from "@/views/components/select/comp/PersonSelect.vue"
import {exportApi} from "@/api/module/export/export";

export default {

  name : 'ExportDetail',

  components:{
    PersonSelect,SchedulingSelect
  },

  data(){
    return {
      loading : false,

      selectPersons : [] ,

      users : "",
      studyclasses:"",
      jsondata : null,
      retired : false

    }
  },
  methods:{
    init(){
    },

    onPersonChanged(val1,val2){
      console.log("onPersonChanged",val1,val2)
      this.selectPersons.push(val2);

      this.reloadCache();
    },

    publish(){

      if(this.loading){
        return;
      }

      if(this.selectPersons == null || this.selectPersons.length == 0){
        this.$message.error("no user")
        return;
      }


      this.loading = true;

      let serverUrl = "/api/manager/export/users/detail";

      let uids = new Array();

      for(var i = 0; i < this.selectPersons.length; i++){
        uids.push(this.selectPersons[i].id)
      }

      let data = {
        "uids":uids,
      }

      let filename = "导出详情.xls";

      exportApi(data,serverUrl)
        .then((res)=>{
          let data = res.data;
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click()
        })
        .finally(()=>{
          this.loading = false;
        })


    },

    reloadCache(){
      localStorage.setItem("export_details_user", JSON.stringify(this.selectPersons))
    }



  },

  mounted(){
    var cacheP = localStorage.getItem("export_details_user");
    if(cacheP){
      this.selectPersons = JSON.parse(cacheP);
    }
  },

  created() {

  }



}
</script>
<style scoped lang="scss">
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}

.select_user_row{
  margin-top: 0px;
  margin-bottom: 0px;

  max-height: 300px;
  overflow-y: auto;

  p {
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
</style>